import * as THREE from 'three'
import { bezier2D } from '../../Utils/Bezier'
import Experience from '../../Experience'
import { ParametricGeometry } from 'three/examples/jsm/Addons.js'
import anim from '../../Utils/Anim'
import vertexShader from '../../../shaders/souls/vertex.glsl'
import fragmentShader from '../../../shaders/souls/fragment.glsl'

export default class Soul {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.ui = this.experience.debug.ui
        this.position = _options.position
        this.debugFolder = _options.debugFolder
        this.index = _options.index
        this.isRandom = _options.isRandom
        this.isRed = _options.isRed ?? false

        // 
        this.meshTime = 0
        this.speed = 0
        this.isAnimating = false
        // 
        const p1x = 0
        const p2x = this.isRandom ? Math.random() * 1.5 : 0.7
        const p3x = (this.isRandom && p2x > 0.6) ? (Math.random() * 0.4 * 2 - 0.2) : 0.4
        const p4x = this.isRandom ? Math.random() * 0.8 : 0.7
        // 
        this.P1 = { x: p1x, y: 1 };
        this.P2 = { x: p2x, y: 1 };
        this.P3 = { x: p3x, y: 0 };
        this.P4 = { x: p4x, y: 0 };

        this.setMesh()

        // debug
        this.setDebug()
        // emotionsTest
        setInterval(() => {
        }, 5000 + Math.random() * 5000)
    }
    catchIdea() {
        this.material.uniforms.u_idea.value = 1.5
        anim.to(this.material.uniforms.u_idea, {
            value: -1.5,
            duration: 1,
        })

    }
    setEmotion(emotion) {
        if (emotion === "happy" && this.material) {
            anim.to(this.material.uniforms.u_mixHappy, { value: 1, duration: 1 })
            anim.to(this.material.uniforms.u_mixSad, { value: 0, duration: 1 })
            anim.to(this.material.uniforms.u_mixRound, { value: 0, duration: 1 })
        }
        if (emotion === "sad" && this.material) {
            anim.to(this.material.uniforms.u_mixHappy, { value: 0, duration: 1 })
            anim.to(this.material.uniforms.u_mixSad, { value: 1, duration: 1 })
            anim.to(this.material.uniforms.u_mixRound, { value: 0, duration: 1 })
        }
        if (emotion === "round" && this.material) {
            anim.to(this.material.uniforms.u_mixHappy, { value: 0, duration: 1 })
            anim.to(this.material.uniforms.u_mixSad, { value: 0, duration: 1 })
            anim.to(this.material.uniforms.u_mixRound, { value: 1, duration: 1 })
        }

    }
    getIdea() {
        this.isAnimating = true
        this.hasTriggered = false;
        this.hasDropTriggered = false;
        this.hasPressTrigered = false;
        this.getIdeaValue = 0;

        anim.to(this, {
            getIdeaValue: 1,
            duration: 4,
            easing: 'power1.out',

            onUpdate: (progress) => {

                if (this.position) {
                    const bezier = bezier2D(this.getIdeaValue, -1.5, -1.7, 0, 0, 1, 0.5, -1, -0.5)
                    this.position.x = bezier.x
                    this.position.z = bezier.y
                    if (!this.hasPressTrigered && progress > 0) {
                        this.experience.world.tableaux.tableau1.trigger('press')

                        this.hasPressTrigered = true;
                    }
                    if (!this.hasTriggered && progress > 0.3 && progress < 0.5) {
                        this.experience.world.tableaux.tableau1.trigger('goTo')
                        this.hasTriggered = true;
                    }
                    if (!this.hasDropTriggered && progress > 0.9 && progress < 1) {
                        this.experience.world.tableaux.tableau1.trigger('drop')
                        this.hasDropTriggered = true;
                        anim.to(this.material.uniforms.u_gotIdea, { value: 1, duration: 1 })

                        this.catchIdea()
                    }
                }

            },
            onComplete: () => {
                this.leaveScene()
                this.setEmotion(this.emotions[Math.floor(Math.random() * 3)])

                this.experience.world.tableaux.tableau1.trigger('ideaGot')

            }

        })

    }
    //! faire tous ca avec une seul courbe ca doit etre smooth
    leaveScene() {
        this.leaveSceneValue = 0
        anim.to(this, {
            leaveSceneValue: 1,
            duration: 5,
            easing: 'power1.inout',
            onUpdate: (progress) => {

                const bezier = bezier2D(this.leaveSceneValue, 0, 2.3, -1, 4, -0.5, -0.5, 1, 1)
                this.position.x = bezier.x
                this.position.z = bezier.y
            },
            onComplete: () => {
                this.experience.world.tableaux.tableau1.trigger('soulLeft')
                this.isAnimating = false
                this.material.uniforms.u_gotIdea.value = 0


            }


        })

    }
    getRadius(v) {
        return bezier2D(
            v,
            this.P1.x, this.P2.x, this.P3.x, this.P4.x,
            this.P1.y, this.P2.y, this.P3.y, this.P4.y
        ).x;
    }

    getHeight(v) {
        return bezier2D(
            v,
            this.P1.x, this.P2.x, this.P3.x, this.P4.x,
            this.P1.y, this.P2.y, this.P3.y, this.P4.y
        ).y;
    }


    updateMesh() {
        this.scene.remove(this.mesh)
        this.geometry.dispose()
        this.mesh.geometry.dispose()
        this.mesh.material.dispose()

        this.setMesh()

    }


    setMesh() {
        this.geometry = new ParametricGeometry((u, v, target) => {
            let radius = 1
            let x = Math.cos(u * Math.PI * 2) * this.getRadius(v)
            let y = this.getHeight(v) - 0.5
            // let y = Math.min((v - 0.5) * 1, 0.5)
            // let y = (v - 0.5)
            let z = Math.sin(u * Math.PI * 2) * this.getRadius(v)
            target.set(x, y, z)
        }, 252, 32);
        this.geometry.computeVertexNormals()
        // this.material = new THREE.MeshNormalMaterial({ side: THREE.DoubleSide, wireframe: false })
        this.emotions = ["happy", "round", "sad"]
        this.material = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            // side: THREE.DoubleSide,
            // depthWrite: false,
            // depthTest: true,
            blending: THREE.NormalBlending,
            wireframe: false,
            transparent: true,
            uniforms: {
                u_time: new THREE.Uniform(0),
                u_amplitude: new THREE.Uniform(0.5),
                u_powerShine: new THREE.Uniform(0.1),
                u_idea: new THREE.Uniform(1.5),
                u_mixSad: new THREE.Uniform(0),
                u_mixHappy: new THREE.Uniform(0),
                u_mixRound: new THREE.Uniform(1),
                u_gotIdea: new THREE.Uniform(0),
                u_flat: new THREE.Uniform(0),
                u_appear: new THREE.Uniform(1),
                u_noise: new THREE.Uniform(this.experience.ressources.items.noise),
                u_red: new THREE.Uniform(0),

            }
        })
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.copy(this.position)
        this.mesh.layers.enable(1)
        this.mesh.scale.set(0.15, 0.15, 0.15)
        // this.mesh.scale.set(0.5, 0.5, 0.5)
        // this.mesh.position.y = this.mesh.scale.x * 0.5 + 0.01
        // this.position.y = this.mesh.position.y
        this.scene.add(this.mesh)


    }

    setDebug() {
        if (this.experience.debug.active && this.debugFolder) {
            const soulFolder = this.debugFolder.addFolder('soul')
            // soulFolder.close()

            this.debugObject = {
                p1X: this.P1.x,
                p2X: this.P2.x,
                p3X: this.P3.x,
                p4X: this.P4.x,
                speed: this.speed,
                scale: this.mesh.scale.x,
                getIdeaValue: this.getIdeaValue,
                leaveSceneValue: this.leaveSceneValue,
                selectedEmotion: this.emotions[1],
                emotions: this.emotions,
                getIdea: () => { this.getIdea() },
                leaveScene: () => { this.leaveScene() },
            }
            // this.mesh.scale.set(this.debugObject.scale, this.debugObject.scale, this.debugObject.scale)
            const bezierFolder = soulFolder.addFolder('Bézier')
            bezierFolder.close()

            bezierFolder.add(this.debugObject, 'p1X').min(-1).max(2).onChange((value) => {
                this.P1.x = value
                this.updateMesh()
            })
            bezierFolder.add(this.debugObject, 'p2X').min(-1).max(2).onChange((value) => {
                this.P2.x = value
                this.updateMesh()
            })
            bezierFolder.add(this.debugObject, 'p3X').min(-1).max(2).onChange((value) => {
                this.P3.x = value
                this.updateMesh()
            })
            bezierFolder.add(this.debugObject, 'p4X').min(-1).max(10).onChange((value) => {
                this.P4.x = value
                this.updateMesh()
            })
            soulFolder.add(this.debugObject, 'selectedEmotion', this.debugObject.emotions).name('emotions').onChange((value) => {
                this.setEmotion(value)


            })
            soulFolder.add(this.mesh.material, 'wireframe').name('wireframe')

            soulFolder.add(this.position, 'x').min(-2).max(2).name('positionX')
            soulFolder.add(this.position, 'y').min(-2).max(2).name('positionY')
            soulFolder.add(this.position, 'z').min(-2).max(2).name('positionZ')
            soulFolder.add(this.mesh.material.uniforms.u_amplitude, 'value').min(0).max(2).name('amplitude').onChange((value) => {
                this.mesh.material.uniforms.u_amplitude.value = value
            })
            soulFolder.add(this.mesh.material.uniforms.u_idea, 'value').min(0).max(2).name('u_idea').onChange((value) => {
                this.mesh.material.uniforms.u_idea.value = value
            })
            soulFolder.add(this.mesh.material.uniforms.u_powerShine, 'value').min(0).max(2).name('shining power').onChange((value) => {
                this.mesh.material.uniforms.u_powerShine.value = value
            })
            soulFolder.add(this.debugObject, 'speed').min(0).max(10).step(0.01).onChange((value) => {
                this.speed = value
            })
            soulFolder.add(this.debugObject, 'scale').min(0).max(2).step(0.01).onChange((value) => {
                this.mesh.scale.set(value, value, value)
                this.mesh.position.y = this.mesh.scale.x * 0.5 + 0.01

            })
            soulFolder.add(this.debugObject, 'getIdea')
            soulFolder.add(this.debugObject, 'leaveScene')

        }

    }
    destroy() {
        // Supprimer l'objet de la scène
        if (this.mesh && this.scene) {
            this.scene.remove(this.mesh);
        }
        // Nettoyer les géométries, matériaux et autres ressources utilisées
        if (this.geometry) {
            this.geometry.dispose();
        }
        if (this.mesh && this.mesh.geometry) {
            this.mesh.geometry.dispose();
        }
        if (this.mesh && this.mesh.material) {
            this.mesh.material.dispose();
        }
        // Supprimer toutes les animations et effets liés
        if (this.material && this.material.uniforms) {
            for (let key in this.material.uniforms) {
                if (this.material.uniforms[key] instanceof THREE.Uniform) {
                    this.material.uniforms[key].value = null;
                }
            }
        }

        // Si l'objet a des debugFolders, les supprimer
        if (this.debugFolder) {
            this.debugFolder.destroy(); // Supposé que cette méthode existe pour détruire les dossiers
        }


    }
    disapear() {
        this.material.uniforms.u_appear.value = 1

        anim.to(this.material.uniforms.u_appear, {
            value: 0,
            duration: 1,
            easing: 'power2.inout',
            onComplete: () => {
                this.material.uniforms.u_appear.value = 0
            }

        })
    }
    appear() {
        this.material.uniforms.u_appear.value = 0

        anim.to(this.material.uniforms.u_appear, {
            value: 1,
            duration: 1,
            easing: 'power2.inout',
            onComplete: () => {
                this.material.uniforms.u_appear.value = 1
            }

        })

    }

    update() {
        if (!this.prevDirection) {
            this.prevDirection = new THREE.Vector3(0.001, 0, 0); // par défaut, regarder vers X
        }

        const prevPos = this.mesh.position.clone();
        const newPos = new THREE.Vector3(this.position.x, this.position.y, this.position.z);
        this.mesh.position.copy(newPos);


        let direction = new THREE.Vector3().subVectors(newPos, prevPos);

        // Si la direction est trop faible, on garde la précédente
        if (direction.lengthSq() < 1e-6) {
            direction = this.prevDirection.clone();
            direction.normalize().multiplyScalar(0.001);


        } else {

            this.prevDirection.copy(direction);
        }

        const target = new THREE.Vector3().addVectors(this.position, direction);
        const lookAtMatrix = new THREE.Matrix4().lookAt(this.position, target, this.mesh.up);
        const targetQuat = new THREE.Quaternion().setFromRotationMatrix(lookAtMatrix);

        // Appliquer une rotation supplémentaire
        const extraRotation = new THREE.Quaternion().setFromAxisAngle(
            new THREE.Vector3(0, 1, 0),
            -Math.PI / 2
        );
        targetQuat.multiply(extraRotation);

        this.mesh.quaternion.slerp(targetQuat, 0.1);

        // Mettre à jour le temps en fonction de la vitesse
        // ! REECRIR LA FONCTION POUR QUE LA SPEED NE SOIT PAS FONCTION DE LA DIRECTION
        this.speed = direction.length() * 1000 * 5;

        this.meshTime += this.time.delta * this.speed;

        this.material.uniforms.u_time.value = this.meshTime;


    }
}